import { makeStyles } from '@material-ui/core';
import { backgroundColorLogin } from 'app/utils/coresUtil';

export const TelaBloqueioStyles = makeStyles(() => ({
  container: {
    backgroundColor: backgroundColorLogin,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
  },
  card: {
    maxWidth: '60%',
  },
  ops: {
    fontSize: '60px',
    marginBottom: '50px',
  },
  divParagrafo: {
    marginTop: '30px',
    marginBottom: '30px',
  },
  divParagrafoSemTitulo: {
    marginTop: '120px',
  },
  paragrafo: {
    fontSize: '22px',
    lineHeight: '1.9',
  },
  actions: {
    padding: '20px',
  },
  botaoSair: {
    border: '1px solid #5890AA',
    color: '#5890AA',
    height: 36,
    borderRadius: 5,
    backgroundColor: '#eee',
    textTransform: 'capitalize',
    fontSize: '20px',
    fontFamily: 'Arial',
    '&:hover': {
      background: '#eee',
      color: '#5890AA',
    },
  },
  botaoAdicional: {
    marginLeft: '10px',
    background: '#305F74',
    color: 'white',
    '&:hover': {
      background: '#305F74',
      color: 'white',
    },
  },
}));
